var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",null,{"rowId":_vm.rowId,"metrics":_vm.metrics,"emptyValue":_vm.timeseries.emptyValue,"time":_vm.timeseries.time})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }